import React from "react";
import moment from "moment";
import * as Glob from "../../Globale";
import useReducerOnChange from "../../hooks/ReducerOnChange";
import { EmploymentForm, LoanForm, LoanFormDPS, LoanSimulation, OtherLiabilitiesForm, AnalyserWrapper, PageWrapper } from "../../components";
import { DaysNumber, MonthsNumber, Nav, WeeksNumber } from "../../components/DigitalProductAnalyser/Constants";
import "../../components/DigitalProductAnalyser/style.css";

export class CDataPrimaryAnalyser {
    public DateOfBirth: Date = new Date("2000-01-01");
    public Duration: string = "24";
    public EffectiveDate: Date = new Date(Date.now());
    public EmploymentDate: Date = new Date("2020-01-01");
}

export class CDataEmploymentItem {
    public ContributionType: string = "";
    public Days: number = 0;
    public Weeks: number = 0;
    public Months: number = 0;
    public Years: number = 0;
    public IsCounted: boolean = false;
}

export class CDataLiabilityItem {
    public LiabilityType: string = "";
    public Amount: number = 0;
    public ResidualDebt: number = 0;
    public ExpiryDate: Date | string = "";
    public Insurer: string = "";
}

interface IPrimaryAnalyserProps extends Glob.IRouteGlobaleProps {
    IsDpsPage?: boolean;
}

export const PrimaryAnalyser: React.FC<IPrimaryAnalyserProps> = props => {
    const [FormData, setFormData] = useReducerOnChange<CDataPrimaryAnalyser>(new CDataPrimaryAnalyser());
    const [EmploymentData, setEmploymentData] = useReducerOnChange<CDataEmploymentItem[]>([new CDataEmploymentItem()]);
    const [LiabilitiesData, setLiabilitiesData] = useReducerOnChange<CDataLiabilityItem[]>([new CDataLiabilityItem()]);

    const session = (props.match.params as any).Sessione;

    const getPreviousEmploymentLength = () => {
        const isEmploymentFormValid = !EmploymentData.filter(item => {
            const isPeriodSet: boolean = !!(item.Days || item.Weeks || item.Months || item.Years);
            return (item.ContributionType && !isPeriodSet) || (!item.ContributionType && isPeriodSet);
        }).length;
        let days = 0;
        let agriculturalDays = 0;
        let weeks = 0;
        let months = 0;
        let years = 0;

        if (!isEmploymentFormValid) {
            return moment.duration(0);
        }

        EmploymentData.filter(item => item.IsCounted).forEach(item => {
            if (item.ContributionType == "5") {
                agriculturalDays += item.Days;
            } else {
                days += item.Days;
                weeks += item.Weeks;
                months += item.Months;
                years += item.Years;
            }
        });
        months += Math.floor(weeks / WeeksNumber.Month);
        weeks -= Math.floor(weeks / WeeksNumber.Month) * WeeksNumber.Month;
        days += weeks * DaysNumber.Week;
        months += Math.floor(days / DaysNumber.Month);
        days -= Math.floor(days / DaysNumber.Month) * DaysNumber.Month;
        years += Math.floor(agriculturalDays / DaysNumber.AgricultureYear);
        years += Math.floor(months / MonthsNumber.Year);
        months -= Math.floor(months / MonthsNumber.Year) * MonthsNumber.Year;

        return moment.duration({ days, months, years });
    };

    const currentEmploymentLength = moment.duration(moment(FormData.EffectiveDate).diff(FormData.EmploymentDate));
    const previousEmploymentLength = getPreviousEmploymentLength();
    const totalEmploymentLength = previousEmploymentLength.clone().add(currentEmploymentLength);

    const employmentLength = {
        previous: previousEmploymentLength,
        current: currentEmploymentLength,
        total: totalEmploymentLength
    };

    return (
        <div className="page_dpa kt-wrapper" id="kt_wrapper">
            <PageWrapper Session={session}>
                <AnalyserWrapper NavItems={props.IsDpsPage ? Nav["DPS"] : Nav["Main"]} Session={session}>
                    <div className="tab-pane active" id="loan_form" role="tabpanel">
                        {props.IsDpsPage ? (
                            <LoanFormDPS
                                FormData={FormData}
                                TotalEmploymentLength={totalEmploymentLength}
                                LiabilitiesData={LiabilitiesData}
                                OnChange={(e, v) =>
                                    setFormData({
                                        Type: "OnChangeFromHybrid",
                                        NameEvent: e,
                                        Value: v
                                    })
                                }
                            />
                        ) : (
                            <LoanForm
                                FormData={FormData}
                                TotalEmploymentLength={totalEmploymentLength}
                                LiabilitiesData={LiabilitiesData}
                                OnChange={(e, v) =>
                                    setFormData({
                                        Type: "OnChangeFromHybrid",
                                        NameEvent: e,
                                        Value: v
                                    })
                                }
                            />
                        )}
                    </div>
                    <div className="tab-pane" id="other_liabilities_form" role="tabpanel">
                        <OtherLiabilitiesForm Data={LiabilitiesData} OnChange={setLiabilitiesData} IsDpsPage={props.IsDpsPage} />
                    </div>
                    <div className="tab-pane" id="employment_form" role="tabpanel">
                        <EmploymentForm EmploymentLength={employmentLength} Data={EmploymentData} OnChange={setEmploymentData} />
                    </div>
                    <div className="tab-pane" id="loan_simulation" role="tabpanel">
                        <LoanSimulation FormData={FormData} TotalEmploymentLength={totalEmploymentLength.clone()} />
                    </div>
                </AnalyserWrapper>
            </PageWrapper>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/form/DigitalProductAnalyser/PrimaryAnalyser.tsx